<section id="products-section" class="feat-pro2 pt-4">
  <div class="container">
    <div class="row">
      <div class="col-md-12 d-flex justify-content-center">
        <h2 class="p-2 font-weight-bold text-center section-title">Más vendidos de Best Buy en Cubatel</h2>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 padding-fix-l20">
        <div class="ftr-product">
          <div class="tab-box d-flex justify-content-center text-center">
            <!-- Nav tabs -->
            <ul class="nav nav-tabs center-nav-tabs" role="tablist">
              <li class="nav-item">
                <a (click)="updatePayload(1)" class="nav-link active p-1 px-3" data-toggle="tab" href="#treading-items">Televisores</a>
              </li>
              <li class="nav-item">
                <a (click)="updatePayload(2)" class="nav-link p-1 px-3" data-toggle="tab" href="#new-arrivals">Electrodomésticos</a>
              </li>
              <li class="nav-item">
                <a (click)="updatePayload(3)" class="nav-link p-1 px-3" data-toggle="tab" href="#newest">Teléfonos</a>
              </li>
            </ul>
          </div>
          <div class="tab-content">
            <div class="tab-pane fade active show" id="treading-items" role="tabpanel">
              <ng-container *ngTemplateOutlet="tabs; context: {tab: 1}"></ng-container>
            </div>
            <div class="tab-pane" id="new-arrivals" role="tabpanel">
              <ng-container *ngTemplateOutlet="tabs; context: {tab: 2}"></ng-container>
            </div>
            <div class="tab-pane" id="best-sale" role="tabpanel">
              <ng-container *ngTemplateOutlet="tabs; context: {tab: 3}"></ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div id="products-tab-box">

  </div>
</section>
<ng-template #loading_items>
  <div #product_section_slider_loading class="tab-slider" id="product-section-slider-loading">
    <div *ngFor="let number of [1,2,3,4]" class="tab-item">
      <div class="tab-img">
        <div class="d-flex justify-content-center align-items-center" style="height: 0; padding-bottom: 100%">
          <div class="animated-background animated-images mb-5" style="margin-left:1rem;margin-right: 1rem;"></div>
        </div>
      </div>
      <div class="tab-heading">
        <div class="animated-background mb-2" style="margin-left:1rem;margin-right: 1rem;"></div>
      </div>
      <div class="img-content d-flex justify-content-between">
        <div style="width:100%">

          <ul class="list-unstyled list-inline price" style="width:100%">
            <li class="list-inline-item" style="width:100%">
              <div class="animated-background"></div>
            </li>
            <li class="list-inline-item" style="width:100%">
              <div class="animated-background"></div>
            </li>
          </ul>
        </div>
        <div>
          <a href="" data-toggle="tooltip" data-placement="top" title="Añadir al carrito"><img style="visibility:hidden" src="assets/market/xemart/images/it-cart.png" alt=""></a>
        </div>
      </div>
      <!--<div class="tab-img">
        <div class="d-flex justify-content-center align-items-center" style="height: 0; padding-bottom: 100%">
          <img class="main-img img-fluid m-auto p-2" src="assets/loading.gif" alt="Café">
        </div>
      </div>
      <div class="tab-heading">
        <div class="animated-background mb-2" style="margin-left:1rem;margin-right: 1rem;"></div>
      </div>
      <div class="img-content d-flex justify-content-between">
        <div style="width:100%">

          <ul class="list-unstyled list-inline price" style="width:100%">
            <li class="list-inline-item" style="width:100%">
              <div class="animated-background"></div>
            </li>
            <li class="list-inline-item" style="width:100%">
              <div class="animated-background"></div>
            </li>
          </ul>
        </div>
        <div>
          <a href="" data-toggle="tooltip" data-placement="top" title="Añadir al carrito"><img style="visibility:hidden" src="assets/market/xemart/images/it-cart.png" alt=""></a>
        </div>
      </div>-->
    </div>
  </div>

</ng-template>
<ng-template #snippet>
  <div class="backdrop" style="border-radius: 25px">
    <div class="snippet" data-title="dot-pulse">
      <div class="stage">
        <div class="dot-pulse"></div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #tabs>
  <div class="row">
    <ng-container *ngIf="loading$; else template">
      <div *ngFor="let product of [1,2,3,4]" style="display:flex;" class="col-6 col-md-4 col-lg-3 mb-4">
        <div class="tab-item">
          <div class="tab-img">

            <ngx-skeleton-loader class="d-block d-xl-none" animation="progress" animation="true" appearance="line" [theme]="theme">
            </ngx-skeleton-loader>

            <ngx-skeleton-loader class="d-none d-xl-block" animation="progress" animation="true" appearance="line" [theme]="{ 'min-width': '175px', 'min-height': '190px', background: '#f1f1f1' }">
            </ngx-skeleton-loader>

          </div>
          <div style="min-height: 80px;" class="tab-heading">

            <ngx-skeleton-loader animation="progress" appearance="line"
                                 [theme]="{ margin: '-15px 0 0 10px', width: '160px', height: '28px',background: '#f1f1f1'}">
            </ngx-skeleton-loader>

            <ngx-skeleton-loader animation="progress" appearance="line"
                                 [theme]="{ margin: '0 0 0 10px', width: '110px', height: '20px',background: '#f1f1f1'}">
            </ngx-skeleton-loader>

          </div>

          <div class="img-content d-flex justify-content-between">
            <div style="margin-top:10px">
              <ngx-skeleton-loader animation="progress" appearance="line"
                                   [theme]="{ margin: '5px 0 0 0px', width: '120px', height: '30px',background: '#f1f1f1'}">
              </ngx-skeleton-loader>
            </div>
            <div>
              <ngx-skeleton-loader animation="progress" appearance="circle"
                                   [theme]="{ width: '50px', height: '50px',background: '#f1f1f1'}">
              </ngx-skeleton-loader>
            </div>
          </div>


        </div>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-template #template let-tab="tab">
  <div *ngFor="let product of products; let index = index;" style="display:flex;" class="col-6 col-md-4 col-lg-3 mb-4 items tab-slider">
    <div id="{{tab + '-' + product.code}}" class="tab-item d-flex flex-column">
      <div class="tab-img d-flex justify-content-center">
        <ngx-skeleton-loader [hidden]="product.loaded" animation="progress" appearance="line" [theme]="{ 'min-width': '220px', 'min-height': '190px', background: '#f1f1f1' }">
        </ngx-skeleton-loader>

        <img routerLink="../../../productos-compras-cuba-online/bestbuy/{{product.code}}" [hidden]="!product.loaded" class="main-img img-fluid cursor-pointer" style="max-height: 300px"
             src="{{product.pictures .length>0?product.pictures[0].previewUrl:'assets/xemart/images/notImg.png'}}"
             (load)="product.loaded=true">
      </div>
      <div style="min-height: 80px;" class="tab-heading">
        <p>
          <span class="d-none d-md-block"><a  routerLink='../../../productos-compras-cuba-online/bestbuy/{{product.code}}'>{{(product.name.length>50)? (product.name | slice:0:60)+'...':(product.name)}}</a><i *ngIf="product.name.length>50" [ngbTooltip]="product.name" style="font-size: 16px" class="ml-2 p-2 text-primary fa fa-info-circle"></i></span>
          <span class="d-block d-md-none"><a routerLink='../../../productos-compras-cuba-online/bestbuy/{{product.code}}'>{{(product.name.length>40)? (product.name | slice:0:50)+'...':(product.name)}}</a><i *ngIf="product.name.length>40" [ngbTooltip]="product.name" style="font-size: 16px" class="ml-2 p-2 text-primary fa fa-info-circle"></i></span>
        </p>
        <div class="img-content d-flex justify-content-between">
          <ul title="{{product.rating}}" [innerHtml]="product.rating | start" class="list-unstyled list-inline fav"></ul>
        </div>
      </div>

      <div class="img-content d-flex justify-content-between mt-auto">
        <div style="margin-top:10px">
          <ul class="list-unstyled list-inline price">
            <li class="list-inline-item">{{product.priceToShow}}</li>
            <li class="list-inline-item">{{product.oldPriceToShow}}</li>
          </ul>
        </div>
        <div>
          <a style="width: 42px; height: 42px; text-align: center;" (click)="openDetails(product)" href="javascript:void(0)" data-toggle="tooltip" data-placement="top" title="Añadir al carrito"><img src="assets/market/xemart/images/it-cart.png" alt=""></a>
        </div>
      </div>

    </div>
  </div>
</ng-template>
